/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_EditInputs */

const en_us2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const pt_br2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const es_419_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const pt_pt2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fr_fr2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const de_de2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const it_it2_plan_edit_edit = /** @type {(inputs: Plan_Edit_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Plan_Edit_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_edit = /** @type {((inputs?: Plan_Edit_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_edit(inputs)
	if (locale === "es-419") return es_419_plan_edit_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_edit(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_edit(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_edit(inputs)
	return en_us2_plan_edit_edit(inputs)
});
export { plan_edit_edit as "plan-edit.edit" }